<script>
export default {
  name: "BaseDatatable",
  props: {
    drfprovider: {
      type: Function,
      required: false,
      default: () => null,
    },
    provider: {
      type: Function,
      required: false,
      default: () => null,
    },
    tableheaders: {
      type: [Array, Object],
      required: true,
    },
    perpage: {
      type: Number,
      required: false,
      default: 10,
    },
    pageoptions: {
      type: Array,
      required: false,
      default() {
        let pages = [];
        let perpage = this.perpage;
        for (let index = 1; index <= 3; index++) {
          pages.push(index * perpage);
        }
        return pages;
      },
    },
    sortby: {
      type: String,
      required: false,
      default: "",
    },
    sortdesc: {
      type: NaN,
      required: false,
      default: null,
    },
    emptyText: {
      type: String,
      default: "Sin registros para mostrar",
    },
    emptyFilteredText: {
      type: String,
      default: "No se encontraron registros",
    },
    responsiveTable: {
      type: Boolean,
      default: true,
      required: false,
    },
    filterOption: {
      type: Boolean,
      default: true,
      required: false,
    },
    placeholderSearch: {
      type: String,
      default: "Buscar",
      required: false,
    },
  },
  data() {
    return {
      isBusy: false,
      filter: null,
      totalRows: 1,
      currentPage: 1,
      lastFilter: "",
    };
  },
  methods: {
    onFiltered(filteredItems) {
      if (this.filter !== this.lastFilter) {
        // Trying to resolve filter search issues when
        // changing pages with an active filter
        this.currentPage = 1;
        this.lastFilter = this.filter;
      }
    },
    baseProvider(ctx) {
      let promise = this.drfprovider(ctx);
      if (promise) {
        return promise.then((data) => {
          this.totalRows = data.count;
          return data.results;
        });
      } else {
        return this.provider(ctx);
      }
    },
    refresh() {
      this.$refs.table.refresh();
    },
  },
};
</script>
<template>
  <b-container fluid class="p-0">
    <b-row>
      <b-col sm="12" md="6">
        <b-form-group v-show="filterOption" label-for="filterInput" class="mb-0">
          <b-input-group>
            <div
              class="d-flex align-items-center border border-right-0 border-primary rounded-left"
            >
              <i class="fas fa-search ml-2"></i>
            </div>
            <b-form-input
              class="border-left-0 border-primary"
              id="filterInput"
              v-model="filter"
              debounce="600"
              type="search"
              :placeholder="placeholderSearch"
            ></b-form-input>
            <!-- <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">{{
                $t('datatable.clear')
              }}</b-button>
            </b-input-group-append> -->
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col sm="5" md="6">
        <b-row class="d-flex flex-nowrap justify-content-end">
          <b-col class="d-flex justify-content-end border-right px-2" md="6">
            <!-- <b-button
                variant="outline-primary rounded"
                :class="{ disabled: submitting }"
                @click="confirmSubmit"
                :disabled="submitting"
              >
                <b-spinner v-if="submitting" label="Spinning" small></b-spinner>
                <span v-if="submitting"> {{ $t('saving') }} </span>
                <span v-else>
                  <i class="fas fa-save"></i>&nbsp;<b-badge
                    v-if="selected.length"
                    >{{ selected.length }}</b-badge
                  >

                  {{ $t('save') }}
                </span>
              </b-button>
              <b-button variant="outline-primary rounded-lg  mx-1">
                <i class="fas fa-download"></i>
              </b-button> -->
            <!-- 
              <b-button
                variant="outline-primary rounded-lg"
                @click="clearSelected"
              >
                {{ $t('clear_select') }}
                <i class="fas fa-broom"></i>
              </b-button> -->
            <slot name="buttons"></slot>
          </b-col>

          <b-col md="2" class="d-flex justify-content-end ml-3">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :page-class="['d-none']"
              :prev-class="['border', 'border-primary', 'rounded-left']"
              :next-class="['border', 'border-primary', 'rounded-right']"
              :hide-goto-end-buttons="true"
              :hide-ellipsis="true"
              :per-page="perpage"
              align="left"
              class="my-0"
            >
              <!-- <template #page>
			hola
		</template> -->
            </b-pagination>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- <b-row>
            <b-col sm="5" md="3" class="my-1">
                <b-form-group
                :label="$t('datatable.recordsperpage')"
                label-cols-sm="6"
                label-cols-md="5"
                label-cols-lg="8"
                label-align-sm="right"
                label-size="sm"
                label-for="perPageSelect"
                class="mb-0"
                >
                <b-form-select
                    id="perPageSelect"
                    v-model="perpage"
                    size="sm"
                    :options="pageoptions"
                ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" offset-md="5" md="4" class="my-1">
                <b-form-group
                :label="$t('datatable.filter')"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                label-for="filterInput"
                class="mb-0"
                >
                <b-input-group size="sm">
                    <b-form-input
                    id="filterInput"
                    v-model="filter"
                    debounce="600"
                    type="search"
                    :placeholder="$t('datatable.typetosearch')"
                    ></b-form-input>
                    <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">{{ $t('datatable.clear') }}</b-button>
                    </b-input-group-append>
                </b-input-group>
                </b-form-group>
            </b-col>
        </b-row> -->
    <b-row>
      <b-col class="p-2">
        <b-table
          ref="table"
          class="m-0"
          hover
          :items="baseProvider"
          :fields="tableheaders"
          :per-page="perpage"
          :current-page="currentPage"
          :busy="isBusy"
          :filter="filter"
          :sort-by.sync="sortby"
          :sort-desc.sync="sortdesc"
          :responsive="responsiveTable"
          show-empty
          :empty-text="emptyText"
          :empty-filtered-text="emptyFilteredText"
          @filtered="onFiltered"
          :thead-class="['text-primary']"
        >
          <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"
            ><slot :name="slot" v-bind="scope"
          /></template>
          <template v-slot:table-busy>
            <div class="text-center text-corp my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong> {{ $t("datatable.loading") }}...</strong>
            </div>
          </template>
        </b-table>
        <b-row class="mw-100 mt-2">
          <b-col class="d-flex justify-content-end p-0">
            <div class="d-flex pt-2 pr-3">
              <b class="text-primary">
                {{ !totalRows ? 0 : (currentPage - 1) * perpage + 1 }}
                -
                {{
                  !totalRows
                    ? 0
                    : currentPage * perpage >= totalRows
                    ? totalRows
                    : currentPage * perpage
                }}
                {{ $t("datatable.of") }} {{ totalRows }}
              </b>
            </div>
            <div>
              <b-dropdown id="dropdown-header" variant="outline-primary rounded">
                <template #button-content>
                  <i class="fas fa-cog"></i>
                </template>
                <b-dropdown-header id="dropdown-header-label">
                  {{ $t("datatable.recordsperpage") }}
                </b-dropdown-header>
                <b-dropdown-item-button
                  v-for="option in pageoptions"
                  :key="option"
                  @click="perpage = option"
                >
                  {{ option }}
                </b-dropdown-item-button>
              </b-dropdown>
            </div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perpage"
              :first-class="['border', 'border-primary', 'rounded']"
              :prev-class="['border', 'border-primary', 'rounded']"
              :page-class="['border', 'border-primary', 'rounded']"
              :next-class="['border', 'border-primary', 'rounded']"
              :last-class="['border', 'border-primary', 'rounded']"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- <b-row>
            <b-col sm="5" md="4" class="my-1">
                {{ $t('datatable.showing') }} {{ !totalRows ? 0 : ((currentPage - 1) * perpage) + 1 }} - {{ !totalRows ? 0 : currentPage * perpage >= totalRows ? totalRows : currentPage * perpage }} {{ $t('datatable.of') }} {{ totalRows }} {{ $t('datatable.totalrows') }}
            </b-col>
            <b-col offset-md="5" sm="7" md="3" class="my-1">
                <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perpage"
                align="right"
                size="md"
                class="my-0"
                ></b-pagination>
            </b-col>
        </b-row> -->
  </b-container>
</template>
<style>
.page-item {
  margin: 0px 2px;
}
.page-link {
  border: none;
  color: dimgray;
  margin: 1px;
}

.page-item.active .page-link {
  border: none;
  color: #0570a7;
  background: none;
  /* background: rgba(0, 60, 255, 0.138); */
  font-weight: 900;
}
</style>
